import { Card, Empty } from 'antd';
export default function ArchitecturePage() {
  return <Card style={{marginTop:16}} title="架构设计"><Empty description="请在AI全流程中完成架构设计" /></Card>;
}
